import SocketClient from './../services/socket.service';
import JobsService from './../services/jobs.service';
import SupervisorService from './../services/supervisor.service';
import AuthService from './../services/auth.service';
import UsersService from './../services/users.service';
import Config from './../config';
import store from './../store';
import Cookies from 'cookies-js';
import StatsService from "../services/stats.service";

export default {
    install: function(Vue, options){
        Vue.prototype.$authService = new AuthService(Vue.http, store);
        Vue.prototype.$jobsService = new JobsService(Vue.http);
        Vue.prototype.$supervisorService = new SupervisorService(Vue.http);
        Vue.prototype.$socketClient = new SocketClient(Vue.prototype.$authService);
        Vue.prototype.$usersSerive = new UsersService(Vue.http);
        Vue.prototype.$statsService = new StatsService(Vue.http);
        Vue.prototype.$cookies = Cookies;
        Vue.prototype.$config = Config;
    }
}


// WEBPACK FOOTER //
// ./src/plugins/services.plugin.js